exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mission-publish-confirm-header{padding-top:0px;padding-bottom:0px}.mission-publish-confirm-mail-account{display:flex;flex-direction:column;align-items:center}.mission-publish-confirm-mail-account>p{color:#31708f !important}.mission-publish-confirm-mail-account-icon{margin-right:4px}\n", ""]);

// exports
